import { FormControlLabel, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { memo } from 'react';
import styled from 'styled-components';

import AsyncProfilePicture from '@/components/common/ProfilePicture/AsyncProfilePicture';
import { COLOR, COLOR_FUNCTION, PX_TO_REM } from '@/globalStyles';

interface UserCheckboxProps {
    className?: string;
    initialCheck: boolean;
    value: string;
    name: string;
    avatarUrl?: string | null;
    disabled?: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const UserCheckbox = ({ className, initialCheck, value, onChange, name, avatarUrl, disabled }: UserCheckboxProps) => {
    return (
        <FormControlLabel
            className={className}
            disabled={disabled}
            control={
                <Checkbox
                    sx={{ p: 0, '& .MuiSvgIcon-root': { fontSize: PX_TO_REM[16] } }}
                    checked={initialCheck}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                />
            }
            label={
                <Container>
                    <AsyncProfilePicture size={PX_TO_REM[30]} profilePictureUrl={avatarUrl} />
                    <Typography variant="table_text">{name}</Typography>
                </Container>
            }
            sx={formControlSX(initialCheck)}
        />
    );
};

const formControlSX = (checked: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    padding: `${PX_TO_REM[10]} ${PX_TO_REM[20]}`,
    gap: PX_TO_REM[10],
    margin: 0,
    borderBottom: `1px solid ${COLOR_FUNCTION.border}`,
    cursor: 'pointer',
    background: checked ? `${COLOR.aliceBlue}` : 'transparent',
});

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: ${PX_TO_REM[10]};
`;

const Memoized = memo(UserCheckbox);
const Styled = styled(Memoized)``;
Styled.displayName = 'UserCheckbox';
export default Styled;
